// extracted by mini-css-extract-plugin
module.exports = {"group":"group___1pwyN","list-block":"list-block___1XkzP","title":"title___3EOKs","no-rules":"no-rules___39Xik"};